module.exports = __webpack_public_path__ + "static/media/SmartPub-arrow-down.5a6690a7.svg";